module.exports = __webpack_public_path__ + "static/media/facebook.e30c8598.svg";